import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, ExternalLink, Handshake } from "lucide-react";
import { PageHeader } from "../components/bits";
import { TicketForm } from "./Assistance";

function ContactMe() {
  const [sent, setSent] = useState(false);
  return (
    <div className="card mt-5 p-5" data-testid="avelis-contact-card">
      <div className="mb-3 flex items-center gap-2 font-bold"><Handshake className="h-5 w-5 text-teal-700" /> Être contactée par AVELIS</div>
      {sent ? <p className="text-sm text-slate-600" data-testid="avelis-contact-sent">Merci ! Nous vous recontactons. Suivez la réponse dans <Link to="/assistance" className="font-semibold text-teal-700">Assistance</Link>.</p>
        : <TicketForm category="billing" testid="avelis-contact-form" onDone={() => setSent(true)} />}
    </div>
  );
}

export default function Avelis() {
  return (
    <div data-testid="avelis-page">
      <PageHeader title="Découvrir AVELIS" back="/" />
      <div className="card mb-5 p-5">
        <img src="/brand/avelis-logo.png" alt="AVELIS by DK Soins SRL" className="mb-4 w-[160px]" />
        <p className="text-slate-700">Vous organisez vos journées avec AVELIS Planning. Découvrez comment AVELIS peut également simplifier votre tarification et votre facturation.</p>
        <p className="mt-3 text-sm text-slate-500">AVELIS Planning reste gratuit, sans obligation de devenir cliente.</p>
        <a href="https://avelis.be" target="_blank" rel="noreferrer" className="btn-primary mt-5 w-full" data-testid="avelis-site-link"><ExternalLink className="h-4 w-4" /> avelis.be</a>
      </div>
      <div className="grid gap-2">
        <a href="tel:+32489567888" className="btn-ghost" data-testid="avelis-call-link"><Phone className="h-4 w-4" /> +32 489 56 78 88</a>
        <a href="https://wa.me/32489567888" target="_blank" rel="noreferrer" className="btn-ghost" data-testid="avelis-whatsapp-link"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
        <a href="mailto:contact@avelis.be" className="btn-ghost" data-testid="avelis-email-link"><Mail className="h-4 w-4" /> contact@avelis.be</a>
      </div>
      <ContactMe />
    </div>
  );
}

export function Legal() {
  return (
    <div className="mx-auto max-w-2xl px-5 py-10 text-slate-700" data-testid="legal-page">
      <img src="/brand/avelis-logo.png" alt="AVELIS" className="mb-6 w-[150px]" />
      <h1 className="mb-4 text-2xl font-bold">Conditions d'utilisation et confidentialité</h1>
      <p className="mb-3 rounded-xl bg-amber-50 p-3 text-sm text-amber-900">[Texte provisoire à faire valider juridiquement par AVELIS / DK Soins SRL.]</p>
      <h2 className="mb-1 mt-5 font-bold">Service</h2>
      <p>AVELIS Planning est un outil gratuit d'organisation des disponibilités, des plannings et des missions des infirmières indépendantes, édité par DK Soins SRL. Ce n'est ni un dossier patient ni un logiciel de facturation.</p>
      <h2 className="mb-1 mt-5 font-bold">Données collectées</h2>
      <p>Prénom, nom, adresse e-mail, téléphone facultatif, appartenance aux équipes, disponibilités, affectations, missions et messages organisationnels. Aucune donnée médicale ni donnée concernant des patients ne doit être encodée.</p>
      <h2 className="mb-1 mt-5 font-bold">Finalité et partage</h2>
      <p>Les données servent uniquement au fonctionnement du planning de vos équipes. Elles ne sont visibles que par les membres autorisés de chaque équipe et ne sont pas utilisées à des fins commerciales.</p>
      <h2 className="mb-1 mt-5 font-bold">Vos droits</h2>
      <p>Vous pouvez modifier vos informations et supprimer votre compte à tout moment depuis « Mon profil ». Contact : <a className="underline" href="mailto:contact@avelis.be">contact@avelis.be</a>.</p>
      <h2 className="mb-1 mt-5 font-bold">Conservation</h2>
      <p>[Durée de conservation à définir par AVELIS.]</p>
      <Link to="/" className="btn-primary mt-8 w-full">Retour</Link>
    </div>
  );
}
